// Common translations used across all pages
export const commonTranslations = {
  en: {
    "buttons": {
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "view": "View Details",
      "download": "Download",
      "copy": "Copy",
      "copyLink": "Copy Link",
      "submit": "Submit",
      "back": "Back",
      "close": "Close",
      "start": "Start",
      "stop": "Stop",
      "confirm": "Confirm",
      "OK": "OK",
      "remove": "Remove",
      "retry": "Retry",
      "discard": "Discard Changes"
    },
    "messages": {
      "success": "Success",
      "error": "Error",
      "confirmDelete": "Are you sure you want to delete?",
      "loading": "Loading...",
      "saving": "Saving...",
      "downloading": "Downloading...",
      "processing": "Processing...",
      "copied": "Copied to clipboard"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "pending": "Pending",
      "completed": "Completed",
      "selected": "Selected"
    },
    "minutes": "minutes",
  },
  zh: {
    "buttons": {
      "save": "保存",
      "cancel": "取消",
      "delete": "删除",
      "edit": "编辑",
      "view": "查看详情",
      "download": "下载",
      "copy": "复制",
      "copyLink": "复制链接",
      "submit": "提交",
      "back": "返回",
      "close": "关闭",
      "start": "开始",
      "stop": "停止",
      "confirm": "确认",
      "OK": "确定",
      "remove": "移除",
      "retry": "重试",
      "discard": "丢弃更改"
    },
    "messages": {
      "success": "成功",
      "error": "错误",
      "confirmDelete": "确定要删除吗？",
      "loading": "加载中...",
      "saving": "保存中...",
      "downloading": "下载中...",
      "processing": "处理中...",
      "copied": "已复制到剪贴板"
    },
    "status": {
      "active": "活跃",
      "inactive": "未激活",
      "pending": "待处理",
      "completed": "已完成",
      "selected": "已选择"
    },
    "minutes": "分钟",
  },
  fr: {
    "buttons": {
      "save": "Enregistrer",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "edit": "Modifier",
      "view": "Voir les détails",
      "download": "Télécharger",
      "copy": "Copier",
      "copyLink": "Copier le lien",
      "submit": "Soumettre",
      "back": "Retour",
      "close": "Fermer",
      "start": "Démarrer",
      "stop": "Arrêter",
      "confirm": "Confirmer",
      "OK": "OK",
      "remove": "Supprimer",
      "retry": "Réessayer",
      "discard": "Annuler les modifications"
    },
    "messages": {
      "success": "Succès",
      "error": "Erreur",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer ?",
      "loading": "Chargement...",
      "saving": "Enregistrement...",
      "downloading": "Téléchargement...",
      "processing": "Traitement...",
      "copied": "Copié dans le presse-papiers"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif",
      "pending": "En attente",
      "completed": "Terminé",
      "selected": "Sélectionné"
    },
    "minutes": "minutes",
  },
  nb: {
    "buttons": {
      "save": "Lagre",
      "cancel": "Avbryt",
      "delete": "Slett",
      "edit": "Rediger",
      "view": "Se detaljer",
      "download": "Last ned",
      "copy": "Kopier",
      "copyLink": "Kopier lenke",
      "submit": "Send inn",
      "back": "Tilbake",
      "close": "Lukk",
      "start": "Start",
      "stop": "Stopp",
      "confirm": "Bekreft",
      "OK": "OK",
      "remove": "Fjern",
      "retry": "Prøv igjen",
      "discard": "Forkast endringer"
    },    "messages": {
      "success": "Suksess",
      "error": "Feil",
      "confirmDelete": "Er du sikker på at du vil slette dette?",
      "loading": "Laster...",
      "saving": "Lagrer...",
      "downloading": "Laster ned...",
      "processing": "Behandler...",
      "copied": "Kopiert til utklippstavlen",
      "minutes": "minutter"
    },
    "minutes": "minutter",
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "pending": "Venter",
      "completed": "Fullført",
      "selected": "Valgt"
    }
  },
  nl: {
    "buttons": {
      "save": "Opslaan",
      "cancel": "Annuleren",
      "delete": "Verwijderen",
      "edit": "Bewerken",
      "view": "Details bekijken",
      "download": "Downloaden",
      "copy": "Kopiëren",
      "copyLink": "Link kopiëren",
      "submit": "Indienen",
      "back": "Terug",
      "close": "Sluiten",
      "start": "Starten",
      "stop": "Stoppen",
      "confirm": "Bevestigen",
      "OK": "OK",
      "remove": "Verwijderen",
      "retry": "Opnieuw proberen",
      "discard": "Wijzigingen verwerpen"
    },
    "messages": {
      "success": "Succes",
      "error": "Fout",
      "confirmDelete": "Weet je zeker dat je dit wilt verwijderen?",
      "loading": "Laden...",
      "saving": "Opslaan...",
      "downloading": "Downloaden...",
      "processing": "Verwerken...",
      "copied": "Gekopieerd naar klembord"
    },
    "status": {
      "active": "Actief",
      "inactive": "Inactief",
      "pending": "In behandeling",
      "completed": "Voltooid",
      "selected": "Geselecteerd"
    },
    "minutes": "minuten",
  },
  de: {
    "buttons": {
      "save": "Speichern",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "view": "Details anzeigen",
      "download": "Herunterladen",
      "copy": "Kopieren",
      "copyLink": "Link kopieren",
      "submit": "Absenden",
      "back": "Zurück",
      "close": "Schließen",
      "start": "Starten",
      "stop": "Stoppen",
      "confirm": "Bestätigen",
      "OK": "OK",
      "remove": "Entfernen",
      "retry": "Wiederholen",
      "discard": "Änderungen verwerfen"
    },
    "messages": {
      "success": "Erfolg",
      "error": "Fehler",
      "confirmDelete": "Sind Sie sicher, dass Sie dies löschen möchten?",
      "loading": "Lädt...",
      "saving": "Speichert...",
      "downloading": "Lädt herunter...",
      "processing": "Verarbeitet...",
      "copied": "In Zwischenablage kopiert"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "pending": "Ausstehend",
      "completed": "Abgeschlossen",
      "selected": "Ausgewählt"
    },
    "minutes": "Minuten",
  },
  es: {
    "buttons": {
      "save": "Guardar",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "edit": "Editar",
      "view": "Ver detalles",
      "download": "Descargar",
      "copy": "Copiar",
      "copyLink": "Copiar enlace",
      "submit": "Enviar",
      "back": "Volver",
      "close": "Cerrar",
      "start": "Iniciar",
      "stop": "Detener",
      "confirm": "Confirmar",
      "OK": "Aceptar",
      "remove": "Eliminar",
      "retry": "Reintentar",
      "discard": "Descartar cambios"
    },
    "messages": {
      "success": "Éxito",
      "error": "Error",
      "confirmDelete": "¿Está seguro de que desea eliminar esto?",
      "loading": "Cargando...",
      "saving": "Guardando...",
      "downloading": "Descargando...",
      "processing": "Procesando...",
      "copied": "Copiado al portapapeles"
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo",
      "pending": "Pendiente",
      "completed": "Completado",
      "selected": "Seleccionado"
    },
    "minutes": "minutos",
  },
  pt: {
    "buttons": {
      "save": "Salvar",
      "cancel": "Cancelar",
      "delete": "Excluir",
      "edit": "Editar",
      "view": "Ver detalhes",
      "download": "Baixar",
      "copy": "Copiar",
      "copyLink": "Copiar link",
      "submit": "Enviar",
      "back": "Voltar",
      "close": "Fechar",
      "start": "Iniciar",
      "stop": "Parar",
      "confirm": "Confirmar",
      "OK": "OK",
      "remove": "Remover",
      "retry": "Tentar novamente",
      "discard": "Descartar alterações"
    },
    "messages": {
      "success": "Sucesso",
      "error": "Erro",
      "confirmDelete": "Tem certeza que deseja excluir?",
      "loading": "Carregando...",
      "saving": "Salvando...",
      "downloading": "Baixando...",
      "processing": "Processando...",
      "copied": "Copiado para a área de transferência"
    },
    "status": {
      "active": "Ativo",
      "inactive": "Inativo",
      "pending": "Pendente",
      "completed": "Concluído",
      "selected": "Selecionado"
    },
    "minutes": "minutos",
  },
  ja: {
    "buttons": {
      "save": "保存",
      "cancel": "キャンセル",
      "delete": "削除",
      "edit": "編集",
      "view": "詳細を見る",
      "download": "ダウンロード",
      "copy": "コピー",
      "copyLink": "リンクをコピー",
      "submit": "送信",
      "back": "戻る",
      "close": "閉じる",
      "start": "開始",
      "stop": "停止",
      "confirm": "確認",
      "OK": "OK",
      "remove": "削除",
      "retry": "再試行",
      "discard": "変更を破棄"
    },
    "messages": {
      "success": "成功",
      "error": "エラー",
      "confirmDelete": "本当に削除しますか？",
      "loading": "読み込み中...",
      "saving": "保存中...",
      "downloading": "ダウンロード中...",
      "processing": "処理中...",
      "copied": "クリップボードにコピーしました"
    },
    "status": {
      "active": "アクティブ",
      "inactive": "非アクティブ",
      "pending": "保留中",
      "completed": "完了",
      "selected": "選択済み"
    },
    "minutes": "分",
  },
  ar: {
    "buttons": {
      "save": "حفظ",
      "cancel": "إلغاء",
      "delete": "حذف",
      "edit": "تعديل",
      "view": "عرض التفاصيل",
      "download": "تحميل",
      "copy": "نسخ",
      "copyLink": "نسخ الرابط",
      "submit": "إرسال",
      "back": "رجوع",
      "close": "إغلاق",
      "start": "بدء",
      "stop": "إيقاف",
      "confirm": "تأكيد",
      "OK": "موافق",
      "remove": "إزالة",
      "retry": "إعادة المحاولة",
      "discard": "تجاهل التغييرات"
    },
    "messages": {
      "success": "نجاح",
      "error": "خطأ",
      "confirmDelete": "هل أنت متأكد أنك تريد الحذف؟",
      "loading": "جار التحميل...",
      "saving": "جار الحفظ...",
      "downloading": "جار التحميل...",
      "processing": "جار المعالجة...",
      "copied": "تم النسخ إلى الحافظة"
    },
    "status": {
      "active": "نشط",
      "inactive": "غير نشط",
      "pending": "معلق",
      "completed": "مكتمل",
      "selected": "محدد"
    },
    "minutes": "دقائق",
  }
};
